module.exports = __webpack_public_path__ + "img/concert-extraordinar-de-craciun.488ed2b9.jpg";